import React from 'react';

export const DeactivateIcon:React.FC<React.SVGProps<SVGSVGElement>> = ({ width = 23, height = 23 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1717 0.708496C5.07886 0.708496 0.139648 5.64771 0.139648 11.7406C0.139648 17.8334 5.07886 22.7726 11.1717 22.7726C17.2646 22.7726 22.2038 17.8334 22.2038 11.7406C22.2038 5.64771 17.2646 0.708496 11.1717 0.708496ZM2.8857 11.7406C2.8857 7.1643 6.59549 3.45454 11.1717 3.45454C12.9647 3.45454 14.6246 4.02419 15.9805 4.99216L4.42331 16.5494C3.45534 15.1935 2.8857 13.5336 2.8857 11.7406ZM11.1717 20.0266C9.3798 20.0266 7.72086 19.4577 6.36537 18.4909L17.922 6.93426C18.8889 8.28975 19.4577 9.94874 19.4577 11.7406C19.4578 16.3168 15.748 20.0266 11.1717 20.0266Z"
        fill="#458FFF"
      />
    </svg>
  );
};